// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"26696db1","514":"d5d3afd6","543":"4e94bc56","917":"f6525d0a"}[chunkId] + ".chunk.js";
};